import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Typography,
} from 'darrius';

import styles from './About.module.scss';

export const About = () => {
  return (
    <Container
      className={`${styles['signup-mgm__about']} space-bottom center-sm start-md`}
    >
      <Typography.Title size="3xl" className="center-md space-bottom">
        Saiba como funciona o GetNinjas
      </Typography.Title>
      <Row className="space-bottom center">
        <Col className="col-sm-12 col-md-6">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/phone/step-1.png`}
            alt="Aplicativo do GetNinjas na PlayStore, com o botão de Instalar em Verde Destacado."
            width="300"
          />
        </Col>
        <Col className="col-sm-12 col-md-6">
          <Typography.Subtitle size="l">
            Baixe o aplicativo e cadastre-se no GetNinjas
          </Typography.Subtitle>
          <Typography.Text className={styles.text}>
            O aplicativo está disponível para Android e iOS.
          </Typography.Text>
          <Button.Link size="small" href="https://www.getninjas.com.br/instale">
            Baixar o aplicativo
          </Button.Link>
        </Col>
      </Row>

      <Row className="space-bottom center reverse end-md">
        <Col className="col-md-6 col-sm-12">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/phone/step-2.png`}
            width="300"
            alt="Aplicativo do GetNinjas com os serviços disponíveis para o profissional liberar. Um dos pedidos tem o titulo 'Pintor - Casa ou Apartamento', é para o usuário 'Marcelo D.', está localizado a '7 Km do Profissional'."
          />
        </Col>

        <Col className="col-md-6 col-sm-12">
          <Typography.Subtitle size="l">
            O cliente pede por serviços e esses pedidos aparecem no seu
            aplicativo
          </Typography.Subtitle>
          <Typography.Text className={styles.text}>
            São mais de 200 tipos de serviços, como diarista, pedreiro, buffet
            completo, assistência técnica, maquiador e muito mais.
          </Typography.Text>
        </Col>
      </Row>

      <Row className="space-bottom center">
        <Col className="col-md-4 col-sm-12">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/phone/step-3.png`}
            width="300"
            alt="Imagem do aplicativo com o contato do cliente para liberar, custando 85 moedas. É mostrado o nome do cliente, com o telefone e email ocultado. Abaixo um botão em preto grande escrito 'Liberar Contato'"
          />
        </Col>
        <Col className="col-md-8 col-sm-12">
          <Typography.Subtitle size="l" className={styles.subtitle}>
            Utilize Moedas GetNinjas para entrar em contato com o cliente
          </Typography.Subtitle>
          <Card className={styles['signup-mgm__about__card']}>
            <img
              src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/partner-money-package.svg`}
              alt="Pacote de Moedas GetNinjas"
            />
            <CardBody>
              <Typography.Subtitle size="m">
                Você ganhou um bônus de 10% na primeira compra!
              </Typography.Subtitle>
              <Typography.Text className={styles.text}>
                Por exemplo, se você comprar um Pacote de 1000 Moedas, você
                ganha um bônus de 100 moedas! Para garantir o bônus, baixe o
                aplicativo clicando no botão abaixo:
              </Typography.Text>
              <Button.Link
                size="small"
                href="https://www.getninjas.com.br/instale"
              >
                Baixar o aplicativo
              </Button.Link>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="space-bottom center reverse end-md">
        <Col className="col-md-6 col-sm-12">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/phone/step-4.png`}
            width="300"
            alt="Imagem do WhatsApp, onde o profissional está conversando com o cliente para fechar o pedido depois de liberar o pedido na plataforma do GetNinjas."
          />
        </Col>

        <Col className="col-md-6 col-sm-12">
          <Typography.Subtitle size="l">
            Negocie com o cliente e feche o serviço!
          </Typography.Subtitle>
          <Typography.Text className={styles.text}>
            Todo o lucro dos serviços fechados fica com você. Aproveite esta
            oportunidade de aumentar sua renda!
          </Typography.Text>
        </Col>
      </Row>
    </Container>
  );
};
